"use client";
import { findOpenHourRules } from "@gettactic/helpers/src/reserve/openHourRules";
import { useResourceHourRules } from "@gettactic/hooks";
import type React from "react";
import { useMemo } from "react";
import {
  infoBoxIcon,
  PopoverInfoBox
} from "@/features/map/components/PopoverInfoBox";
import { OpenRuleMessage } from "@/features/reserve/components/RestrictionAlert/OpenRuleMessage";

export interface OpenHourRulesNoticeProps {
  officeId: string;
  resourceId: string;
  /** Selected day, yyyy-MM-dd. */
  date: string;
}

/**
 * Tells the user an "open" holiday or custom-hours rule applies on the
 * selected day. Closed rules already surface as availability errors, but an
 * open one blocks nothing, so nothing else in the panel would mention it.
 */
export const OpenHourRulesNotice: React.FC<OpenHourRulesNoticeProps> = ({
  officeId,
  resourceId,
  date
}) => {
  const { rules } = useResourceHourRules(officeId, resourceId);
  const openRules = useMemo(
    () => findOpenHourRules(rules, date, resourceId),
    [rules, date, resourceId]
  );

  if (openRules.length === 0) {
    return null;
  }

  return (
    <PopoverInfoBox icon={infoBoxIcon}>
      {openRules.map((rule) => (
        <OpenRuleMessage key={rule.id} rule={rule} />
      ))}
    </PopoverInfoBox>
  );
};
